// extracted by mini-css-extract-plugin
export default {"burgerButton":"BurgerButton_burgerButton__Cxpkv"};